import { Button, DatePicker, InputNumber, Spin } from 'antd'
import Axios from 'axios'
import { saveAs } from 'file-saver'
import moment from 'moment'
import React, { useEffect } from 'react'
const { RangePicker } = DatePicker

const ExtractReport: React.FC = props => {
    const [date, setDate] = React.useState([
        moment().startOf('day'),
        moment()
            .startOf('day')
            .add({ days: 1 }),
    ] as [moment.Moment, moment.Moment])
    const [angleThresholdRoll, setAngleThresholdRoll] = React.useState(0)
    const [angleThresholdPitch, setAngleThresholdPitch] = React.useState(0)
    const [rssiLevel, setRssiLevel] = React.useState(0)
    const [CSQLevel, setCSQLevel] = React.useState(0)
    const [uplinkSuccessfulRate, setUplinkSuccessfulRate] = React.useState(0)
    const [batteryAlertThreshold, setBatteryAlertThreshold] = React.useState(0)
    const [largeAngleRoll, setLargeAngleRoll] = React.useState(0)
    const [largeAnglePitch, setLargeAnglePitch] = React.useState(0)
    const [tiltingAngleThreshold, setTiltingAngleThreshold] = React.useState(0)
    const [hour, setHour] = React.useState(0)
    const [loading, setLoading] = React.useState(false)

    useEffect(() => {
        setLoading(true)
        Axios.get('/report-paras')
            .then(res => {
                const {
                    angleThresholdRoll,
                    angleThresholdPitch,
                    rssiLevel,
                    CSQLevel,
                    uplinkSuccessfulRate,
                    batteryAlertThreshold,
                    largeAngleRoll,
                    largeAnglePitch,
                    tiltingAngleThreshold,
                    hour,
                } = res.data

                setAngleThresholdRoll(angleThresholdRoll)
                setAngleThresholdPitch(angleThresholdPitch)
                setRssiLevel(rssiLevel)
                setCSQLevel(CSQLevel)
                setUplinkSuccessfulRate(uplinkSuccessfulRate)
                setBatteryAlertThreshold(batteryAlertThreshold)
                setLargeAngleRoll(largeAngleRoll)
                setLargeAnglePitch(largeAnglePitch)
                setTiltingAngleThreshold(tiltingAngleThreshold)
                setHour(hour)
            })
            .catch(err => {
                console.error(err)
            })
            .finally(() => {
                setLoading(false)
            })
    }, [])

    const onSubmit = () => {
        setLoading(true)
        setLoading(true)
        Axios.post(
            '/reports',
            {
                start: date[0].format('YYYY-MM-DD HH:mm:ss'),
                end: date[1].format('YYYY-MM-DD HH:mm:ss'),
                angleThresholdRoll,
                angleThresholdPitch,
                rssiLevel,
                CSQLevel,
                uplinkSuccessfulRate,
                batteryAlertThreshold,
                largeAngleRoll,
                largeAnglePitch,
                tiltingAngleThreshold,
                hour,
            },
            {
                responseType: 'blob',
            }
        )
            .then(res => {
                const filename = res.headers['content-disposition'].split(`filename="`)[1].slice(0, -1)
                saveAs(res.data, filename)
            })
            .catch(err => console.error)
            .finally(() => {
                setLoading(false)
            })
    }

    return (
        <div>
            <Spin spinning={loading}>
                <table cellPadding={5} style={{ width: '700px' }}>
                    <tbody>
                        <tr>
                            <td align="right">Date Range: </td>
                            <td align="left">
                                <RangePicker
                                    onChange={(date: any) => setDate(date)}
                                    value={date}
                                    showTime
                                    style={{ width: '100%' }}
                                />
                            </td>
                        </tr>

                        <tr>
                            <td align="right">Angle Threshold (Roll)</td>
                            <td>
                                <InputNumber
                                    value={angleThresholdRoll}
                                    onChange={value => setAngleThresholdRoll(value)}
                                />
                            </td>
                        </tr>

                        <tr>
                            <td align="right">Angle Threshold (Pitch)</td>
                            <td>
                                <InputNumber
                                    value={angleThresholdPitch}
                                    onChange={value => setAngleThresholdPitch(value)}
                                />
                            </td>
                        </tr>

                        <tr>
                            <td align="right">RSSI Level</td>
                            <td>
                                <InputNumber value={rssiLevel} onChange={value => setRssiLevel(value)} />
                            </td>
                        </tr>

                        <tr>
                            <td align="right">CSQ Level</td>
                            <td>
                                <InputNumber value={CSQLevel} onChange={value => setCSQLevel(value)} />
                            </td>
                        </tr>

                        <tr>
                            <td align="right">Uplink Successful Rate (USR) %</td>
                            <td>
                                <InputNumber
                                    value={uplinkSuccessfulRate}
                                    onChange={value => setUplinkSuccessfulRate(value)}
                                />
                            </td>
                        </tr>

                        <tr>
                            <td align="right">Battery Alert Threshold</td>
                            <td>
                                <InputNumber
                                    value={batteryAlertThreshold}
                                    onChange={value => setBatteryAlertThreshold(value)}
                                />
                            </td>
                        </tr>

                        <tr>
                            <td align="right">Large Angle (Roll)</td>
                            <td>
                                <InputNumber value={largeAngleRoll} onChange={value => setLargeAngleRoll(value)} />
                            </td>
                        </tr>

                        <tr>
                            <td align="right">Large Angle (Pitch)</td>
                            <td>
                                <InputNumber value={largeAnglePitch} onChange={value => setLargeAnglePitch(value)} />
                            </td>
                        </tr>

                        <tr>
                            <td align="right">Tilting Angle Threshold</td>
                            <td>
                                <InputNumber
                                    value={tiltingAngleThreshold}
                                    onChange={value => setTiltingAngleThreshold(value)}
                                />
                            </td>
                        </tr>

                        <tr>
                            <td align="right">Hour</td>
                            <td>
                                <InputNumber value={hour} onChange={value => setHour(value)} />
                            </td>
                        </tr>

                        <tr>
                            <td></td>
                            <td>
                                <Button type="primary" style={{ width: '100%' }} onClick={onSubmit} disabled={loading}>
                                    Export
                                </Button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Spin>
        </div>
    )
}

export default ExtractReport
